import { Component, Input } from "@angular/core";
import { PortDTO } from "../../../../services/swagger-gen/fordesk";

@Component({
  selector: "port-option",
  templateUrl: "./port-option.component.html"
})
export class PortOptionComponent {
  @Input()
  public item: PortDTO;

  constructor() { }
}
